import React from 'react';
import { Users, BookOpen, Star, Map } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="text-accent" size={24} data-id="element-227" />,
    text: '+500 nutricionistas confían'
  }, {
    icon: <BookOpen className="text-accent" size={24} data-id="element-228" />,
    text: '6+ Tomos + Bonos'
  }, {
    icon: <Star className="text-accent" size={24} data-id="element-229" />,
    text: '4.9/5 calificación ⭐'
  }, {
    icon: <Map className="text-accent" size={24} data-id="element-230" />,
    text: '🇦🇷 Todo el país'
  }];
  return <div className="text-white py-4 border-y border-accent/10" data-id="element-231">
      <div className="max-w-6xl mx-auto px-3" data-id="element-232">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x-0 md:divide-x divide-accent/20" data-id="element-233">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center gap-1" data-id="element-234">
              {stat.icon}
              <span className="font-semibold text-xs md:text-sm" data-id="element-235">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}